import React, { useState, useEffect, useCallback } from "react";
import LoadingImage from "../assets/Loading.gif";
import Loading from "../Loading";
import HTTP_BASE_URL from "../../constants/HttpConstants";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GoCreditCard } from "react-icons/go";
import Header from "../Header";
import Footer from "../Footer";
import { IoArrowBackSharp } from "react-icons/io5";

const Payment = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Extract "id" from the URL
  const customertoken = localStorage.getItem("customertoken");

  const [isLoading, setIsLoading] = useState(true);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState({});
  const [loadingImage, setLoadingImage] = useState(false);
  const [quoteStatus, setQuoteStatus] = useState(null);
  const [minLimit, setMinLimit] = useState(0); // Min limit (10% of total amount)

  const toastrOptions = {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const getQuote = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("id", id);
    try {
      await fetch(HTTP_BASE_URL + "getBalance", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            //     setAmount(selectedData.total_amount.split(".")[0]); // Initialize amount
            const apiData = result.data;
            const selectedData = apiData;
            setQuoteStatus(selectedData);
            // console.log(selectedData);
            if (selectedData) {
              const invoiceAmount = parseFloat(selectedData?.invoice) || null;
              const quoteAmount = parseFloat(selectedData?.quote) || 0;
              const paidAmount = parseFloat(selectedData?.paid) || 0;
            
              if (invoiceAmount) {
                setAmount(invoiceAmount);
                setMinLimit(0); // No 10% validation when invoice exists
                if(paidAmount){
                  setAmount(Math.max(invoiceAmount - paidAmount, 0));
                }
                
            } else {
                setAmount(quoteAmount);
                if(paidAmount){
                  setAmount(Math.max(quoteAmount - paidAmount, 0));
                }
                // setMinLimit(Math.ceil(quoteAmount * 0.1)); // Enforce 10% minimum
                setMinLimit(0);
              }
            }
            // const totalAmount =
            //   parseFloat(selectedData?.invoice) ||
            //   parseFloat(selectedData?.quote) ||
            //   0;
            // setMinLimit(Math.ceil(totalAmount * 0.1));
            // setAmount(Math.floor(totalAmount));
          } else if (result?.code === 1) {
            navigate("/");
          }
        });
    } catch (error) {
      console.error(error);
    }
  }, [id, customertoken, navigate]);

  const inputOnchange = (e) => {
    const { name, value } = e.target;
    // Validate the field
    const errorMessage = validateField(name, value, minLimit);
    setError((prevError) => ({
      ...prevError,
      [name]: errorMessage,
    }));
    setAmount(value); // Update controlled input value
  };

  const validateField = (name, value, minLimit) => {
    let errorMessage = "";
    if (name === "amount") {
      if (!value || isNaN(parseFloat(value))) {
        errorMessage = "Please enter a valid amount.";
      } else if (parseFloat(value) < minLimit) {
        errorMessage = `Amount must be at least 10%.`;
      }
    }
    return errorMessage;
  };

  const paymentSubmit = async (e) => {
    e.preventDefault();
    setLoadingImage(true); // Start loading
    const newErrors = {};
    // Validate OTP field
    const amountError = validateField("amount", amount, minLimit);
    if (amountError) newErrors.amount = amountError;

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors); // Update errors state
      toast.warning("Please enter a valid amount.", { toastrOptions });
      setLoadingImage(false); // Stop loading on validation failure
      return;
    }

    setError({}); // Clear errors
    const fullData = new FormData();
    fullData.append("amount", amount);
    fullData.append("bookingid", id);
    try {
      // Simulate API call or OTP logic
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Replace with your API call
      await fetch(HTTP_BASE_URL + "createPaymentLink", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            // toast.success('successfully!', { toastrOptions })
            // console.log("Payment", result.data);
            setTimeout(() => {
              const url = result.data.shorturl;
              // window.open(url);
              window.location.href = url; // Opens in the same tab
            }, 500);
          } else if (result.code === 1) {
            toast.error("Please fill correct Amount", {
              toastrOptions,
            });
          }
        });
    } catch (error) {
      console.error("Error Amount sent:", error);
    } finally {
      setLoadingImage(false); // Stop loading
    }
  };

  useEffect(() => {
    getQuote();
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, [getQuote]);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Helmet>
            <title>#{id}</title>
          </Helmet>
          <Header />
          <div>
            <div className="container-fluid booking-section login-banner">
              <div className="container">
                <div className="loginModel">
                  <div className="loginContent gstModal-content">
                    <div className="box-flex p-0 m-0">
                      <p className="mainHeading red">
                        <GoCreditCard /> Pay Now
                      </p>
                      <span
                        className="text-span link-btn mb-0"
                        onClick={() => {
                          navigate(`/booking/${id}`);
                        }}
                      >
                        <IoArrowBackSharp />
                        Back
                      </span>
                    </div>
                    <div className="mt-4">
                      <p className="text-para">Your Booking amount is</p>
                      <p className="mainHeading">
                        &#x20b9;
                        {quoteStatus?.balance ? quoteStatus?.balance : (quoteStatus?.invoice || quoteStatus?.quote || 0)}</p>
                       { quoteStatus?.invoice && <p className="text-span italic text-start m-0">Inclusive of all taxes</p>}
                       { !quoteStatus?.invoice && quoteStatus?.quote && <p className="text-span italic text-start m-0">The final amount may be subject to change after the invoice
                    is created.</p>}

                    </div>
                    <form onSubmit={paymentSubmit} autoComplete="off">
                      <div className="form-col p-0">
                        <label htmlFor="amount" className="form-label">
                          Amount <span className="req-span">*</span>
                        </label>
                        <input
                          type="number"
                          name="amount"
                          value={amount || ""}
                          onChange={inputOnchange}
                          id="amount"
                          className="form-control"
                          // placeholder={`Minimum amount ₹ ${minLimit}`}
                        />
                        {error.amount && (
                          <p className="text-para red pt-25">{error.amount}</p>
                        )}
                        {/* <p className="text-para f-12 pt-2 text-center login-para">By logging in, I agree to terms and privacy policy</p> */}
                      </div>
                      <div className="pt-lg-4 pt-3 otp">
                        <button
                          type="submit"
                          className="submit-btn"
                          disabled={loadingImage}
                        >
                          {loadingImage ? (
                            <>
                              <span className="sub-loading">
                                <img
                                  src={LoadingImage}
                                  alt="Progress indicator"
                                  width={25}
                                  height={25}
                                  loading="eager"
                                />
                              </span>{" "}
                              Pay Now
                            </>
                          ) : (
                            "Pay Now"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default Payment;
